import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { ApiSetting } from '@app/application/models/api-setting';

@Injectable({ providedIn: 'root' })
export class ApiSettingService {

    constructor(
        private httpClient: HttpClient
    ) { }

    getAll(): Observable<Array<ApiSetting>> {
        return this.httpClient.get<Array<ApiSetting>>(`${environment.apiUrl}/apisetting`);
    }
    getByType(type: string): Observable<Array<ApiSetting>> {
        return this.httpClient.get<Array<ApiSetting>>(`${environment.apiUrl}/apisetting/${type}`);
    }
}
